import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LockPageComponent } from './lock-page.component';
import { TimerToLock } from './timer-to-lock';

@NgModule({
    declarations: [LockPageComponent],
    imports: [
        CommonModule
    ],
    providers: [TimerToLock],
    exports: [LockPageComponent]
})
export class LockPageModule { }
